<template>
    <div>
      <div>
        <NotificationMessage v-if="showNotification" :message="notificationMessage" :type="notificationType" :duration="5000"/>
      </div>
        <b-row no-gutters>
            <b-col lg="9" md="8">
                <b-card-text class="pt-3 pb-3">
                <div class="titres pr-2" align ="left" >{{JeuRequetesData.nom}}</div>
                </b-card-text>
            </b-col>

            <b-button pill @click.prevent ="getParamsFromJeu(JeuRequetesData.idJeuRequetes); showModalRequetesIn =false"
            align-self="center"
            title="lancer le jeu de requêtes" id="lancer" class="nav-link5">lancer <i class="fas fa-play-circle"></i></b-button>

            <b-button pill @click.prevent ="handleShowModalRequeteInJeu(JeuRequetesData.idJeuRequetes)"
            align-self="center"
            title="visualiser les requêtes du jeu" id="requetesInJeu" class="nav-link1">requetes <i class="fas fa-list"></i></b-button>
        </b-row>
        <div class ="item">   
            <b-col class="mb-2 mt-1 requetes">
                <div class="requete" v-if="showModalLancement!==false" id="lancerJeu">
                        <p bg-variant="light" align="left"
                         class="mb-2">
                            <ModalLancementJeu
                                :jeuRequete="JeuRequetesData"
                                :parametres="parametres"
                                :idjeu="JeuRequetesData.idJeuRequetes"
                                @notification="handleNotification"
                                @close="showModalLancement = false">
                            </ModalLancementJeu>
                        </p>     
                </div>

                <div class="requete" v-if="showModalRequetesIn!==false">
                  <div v-if="requetes.length!==0" style="position:relative; max-height:400px; overflow-y:auto" id="requetesIn">
                    <p bg-variant="light" align="left"
                       v-for="requete in requetes"
                       v-bind:key="requete.idRequete"
                       v-bind:requete="requete" class="mb-2">
                      <RequetesInJeu
                          :requete="requete"
                          :idJeu="JeuRequetesData.idJeuRequetes"
                          class="center">
                      </RequetesInJeu>
                    </p>
                  </div>
                  <div class = "loading" v-if="!loaded">
                    <div class="spinner-border" role="status">
                      <span class="sr-only">Loading...</span>
                    </div>
                    <span class="ml-2">Chargement en cours...</span>
                  </div>
                </div>

            </b-col>      
        </div>  
    </div>   
</template>

<script>
import {useLancementFunctions} from "@/composition/Lancement/lancementList";
import RequetesInJeu from '@/components/Lancement/ModalRequetesIn.vue'
import ModalLancementJeu from '@/components/Lancement/ModalLancementJeu.vue'
import NotificationMessage from "@/components/Notification.vue";

export default {
    name:"LancementItemAccordion",
    components:{
      NotificationMessage,
      RequetesInJeu,
      ModalLancementJeu,
   
    },
    props:{
        JeuRequetesData:{
            type:Object,
            required:true
        },
    },

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  setup(props) {
    return useLancementFunctions(props);
  }
}
</script>

<style>

.titres{
color: white;
}

.other{
  color: white;
}
.loading{
  color: white;
}

</style>